import React from 'react';
import { Button, Table } from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';
import DragVerticalIcon from 'mdi-react/DragVerticalIcon';
import EditOutlineIcon from 'mdi-react/EditOutlineIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import t, { partial } from '../../../util/translation/translation';
import FormCard from '../../../shared/components/custom/FormCard';
import SquareIconButton from '../../../shared/components/custom/SquareIconButton';

const NewsCategoryList = ({
  categoryList,
  usage,
  handleModal,
  handleOrder,
}) => {
  const s = partial('shared');
  const c = partial('NewsCategory');
  const history = useHistory();
  const renderCategories = () => {
    return categoryList.map((category, index) => (
      <Draggable
        key={`category-${category.id}`}
        draggableId={`category-${category.id}`}
        index={index}
      >
        {(provided, snapshot) => (
          <tr
            ref={provided.innerRef}
            {...provided.draggableProps}
            className={`settings-drag-row${
              snapshot.isDragging ? ' rbdnd-dragging' : ''
            }`}
          >
            <td className="table-col--drag" {...provided.dragHandleProps}>
              <DragVerticalIcon size={18} />
            </td>
            <td className="table-stack__primary">
              <span className="settings-order">{index + 1}</span>
              <Link
                to={`/news_category/edit/${category.id}`}
                className="font-weight-500"
              >
                {category.name}
              </Link>
              {category.hidden ? (
                <span className="qb-chip category-tag">{c('hidden')}</span>
              ) : (
                // The app only shows categories that have articles
                usage[category.id]?.newsCount === 0 && (
                  <span className="qb-chip category-tag" title={c('emptyHint')}>
                    {c('emptyHidden')}
                  </span>
                )
              )}
            </td>
            <td data-label={c('type')}>
              <span
                className={`qb-chip category-type category-type--${
                  category.type || 'news'
                }`}
              >
                {c(`type-${category.type || 'news'}`)}
              </span>
            </td>
            <td data-label={c('articles')}>
              {usage[category.id] ? (
                <Link
                  to={`/news?tab=1&category=${category.id}`}
                  className="category-count"
                  title={c('showArticles')}
                >
                  {usage[category.id].newsCount}
                </Link>
              ) : (
                <span className="text-muted">–</span>
              )}
            </td>
            <td data-label={c('feeds')}>
              {usage[category.id]?.providerCount ?? (
                <span className="text-muted">–</span>
              )}
            </td>
            <td className="table-stack__actions">
              <div className="icon-actions justify-content-end">
                <SquareIconButton
                  icon={<EditOutlineIcon />}
                  title={s('edit')}
                  id={`edit-category-${category.id}`}
                  onClick={() =>
                    history.push(`/news_category/edit/${category.id}`)
                  }
                />
                <SquareIconButton
                  icon={<DeleteOutlineIcon />}
                  title={s('delete')}
                  tone="danger"
                  id={`delete-category-${category.id}`}
                  onClick={() =>
                    handleModal(true, category.id, 'news_category')
                  }
                />
              </div>
            </td>
          </tr>
        )}
      </Draggable>
    ));
  };
  const categoryOnDragEnd = ({ destination, source }) => {
    if (!destination) {
      return;
    }
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    const draggedCategory = categoryList[source.index];
    const newCategories = [...categoryList];
    newCategories.splice(source.index, 1);
    newCategories.splice(destination.index, 0, draggedCategory);
    handleOrder(newCategories);
  };
  return (
    <FormCard
      title={
        <>
          {t('shared.newsCategory')}
          <span className="form-card__count">{categoryList.length}</span>
        </>
      }
      actions={
        <Link to="/news_category/create">
          <Button size="sm" color="primary" className="mb-0">
            {s('create')} {s('category').toLowerCase()}
          </Button>
        </Link>
      }
      bodyClassName="form-card__body--flush"
      className="mt-3 mb-3"
    >
      <p className="form-card__intro">{s('dragToReorder')}</p>
      <DragDropContext onDragEnd={categoryOnDragEnd}>
        <Table responsive striped className="table--roomy table--stack mb-0">
          <thead>
            <tr>
              <th className="table-col--drag" />
              <th>{s('name')}</th>
              <th>{c('type')}</th>
              <th>{c('articles')}</th>
              <th>{c('feeds')}</th>
              <th />
            </tr>
          </thead>
          <Droppable droppableId="category-dnd">
            {(provided) => (
              <tbody {...provided.droppableProps} ref={provided.innerRef}>
                {renderCategories()}
                {provided.placeholder}
                {!categoryList.length && (
                  <tr>
                    <td colSpan={6} className="settings-empty">
                      {s('noCategories')}
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </Droppable>
        </Table>
      </DragDropContext>
    </FormCard>
  );
};

NewsCategoryList.defaultProps = {
  usage: {},
};

export default NewsCategoryList;
